<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TVoZJb/tc-custom/CoverDesign.jpg?1685203789493?1685556936737" alt="This image is the cover for the book Once in a Lifetime, 2018 Advent Calendar - Warmest Wishes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Once in a Lifetime, 2018 Advent Calendar - Warmest Wishes
      </h1>
      <p class="bookDescription body article font2">
        <p>All his life, astrophysicist Peter has dreamed of seeing the comet that last appeared on his birthday—and won’t be seen for another thirty-eight years. Since it could be his only chance, he travels to New Zealand. But his dream might be quashed after all when his rental car breaks down on the way to the observatory. He doesn’t even have a place to stay.</p> <p>Fortunately a New Zealand native with a heart of gold offers assistance. But is kindness the only thing drawing the two men together?</p> <p>Rangi can’t leave Peter stranded so close to Christmas, and his family has plenty of room—and love—to share. While Rangi is attracted to Peter, he’s seen too many of his friends get their hearts broken by tourists. Will they manage to see the comet on its decades-long journey across the sky… and take advantage of a rare opportunity that might never come again?</p><p><i>A story from the Dreamspinner Press 2018 Advent Calendar "Warmest Wishes."</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cassie Decker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21883820